<template>
	<section>
		<div
			class="shadow-box section-content"
			v-if="noOrder || (user.order && !user.order.closed)"
		>
			<div class="top-panel">

                <h2
                    v-html="$mq.isDesktop() 
                        ? 'Dimenticato qualcosa?'
                        : 'Dimenticato qualcosa?'"
                />

                <p>Aggiungi i tuoi preferiti alla tua spesa, hai tempo fino a {{ order && $_dates_readableDate(order.date.cutoff) }}</p>

			</div>
			<div
				class="recipes"
			>
				<ecommerce-slider />
			</div>

			<router-link
				:to="{ name: 'ecommerce' }"
				v-if="isOrderActive"
			>
				<CTA
					:content="`Aggiungi prodotti`"
					isStar
					:color="`orange`"
				/>
			</router-link>

			<router-link
				:to="{ name: 'flow-subscribed' }"
				v-else
			>
				<CTA
					:content="`Fai la tua spesa`"
					isArrow
				/>
			</router-link>
		</div>
	</section>
</template>

<script>

import { dashboard } from '../../mixins/dashboard'
import EcommerceSlider from '../Ecommerce/EcommerceSlider'
import CTA from '../Elements/CTA'
const moment = require('moment')

export default {
	mixins: [
		dashboard
	],

	components: {
		EcommerceSlider,
		CTA
	},

	methods: {
		$_dates_readableDate (date) {
			return moment(date).locale('it').format('dddd D MMMM')+" alle "+moment(date).locale('it').format('HH:mm')
		},
	},
	computed: {
		user () {
			return this.$root.$data.user
		},
		order () {
			return this.user ? this.user.order : null
		},

		isOrderActive () {
			return !this.noOrder && !this.suspendedOrSkipped
		}
	}
}

</script>

<style scoped>
.section-content {
	padding: 30px 50px;
}

.recipe-name {
	padding: 7px;
	position: relative;
	line-height: 1.3;
}

.recipe {
	height: 100%;
}

.top-panel {
	margin-bottom: 20px;
}

.section-content {
	padding: 30px 50px;
	position: relative;
}

.recipes {
	margin: 0 -10px;
}

* >>> .items-container {
	justify-content: flex-start !important;
}

* >>> .slider-container.noArrows {
	margin: 0 0px;
}

@media (max-width: 800px) {
	.top-panel > div {
		flex-basis: 100%;
		text-align: left;
	}
}

@media only screen and (max-width: 640px) {
	.section-content {
		padding: 10px 50px;
	}
}
</style>
